// components/ThemeToggle.jsx
import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { DarkMode, LightMode } from '@mui/icons-material';

const ThemeToggle = ({ isDark, onToggle }) => {
    return (
        <Tooltip title={`Switch to ${isDark ? 'light' : 'dark'} mode`}>
            <IconButton
                onClick={onToggle}
                sx={{
                    color: 'var(--text-primary)',
                    '&:hover': {
                        backgroundColor: 'var(--hover-color)'
                    }
                }}
            >
                {isDark ? <LightMode /> : <DarkMode />}
            </IconButton>
        </Tooltip>
    );
};

export default ThemeToggle;